export interface NumberRange {
  min?: number;
  max?: number;
  wholeNumber?: boolean;
}

export const NON_NEGATIVE_RANGE: NumberRange = { min: 0 };

export function parseNumberInRange(raw: string, range: NumberRange): number | null {
  const trimmed = raw.trim();
  if (trimmed === "") return null;
  const value = Number(trimmed);
  if (!Number.isFinite(value)) return null;
  if (range.min !== undefined && value < range.min) return null;
  if (range.max !== undefined && value > range.max) return null;
  if (range.wholeNumber === true && !Number.isInteger(value)) return null;
  return value;
}

export function parseNonNegativeNumber(raw: string): number | null {
  return parseNumberInRange(raw, NON_NEGATIVE_RANGE);
}

function describeBound(bound: number): string {
  return bound === 0 ? "zero" : String(bound);
}

export function describeNumberRange(range: NumberRange): string {
  const kind = range.wholeNumber === true ? "a whole number" : "a number";
  const { min, max } = range;
  if (min !== undefined && max !== undefined) return `Enter ${kind} from ${min} to ${max}.`;
  if (min !== undefined) return `Enter ${kind} of ${describeBound(min)} or more.`;
  if (max !== undefined) return `Enter ${kind} of ${describeBound(max)} or less.`;
  return `Enter ${kind}.`;
}
